export const SURVEY_COMPARISON_SELECTION = "SurveyComparisonSelection";
